export enum EProductHeaderColumEnum {
  TITLE = 'title',
  PARTNERS = 'partners',
  MODIFIED_TIMESTAMP = 'modifiedTimestamp',
  CREATED_TIMESTAMP = 'createdTimestamp',
  ACTIONS = 'actions',
}

export const HEADER_COLUMNS = [
  {
    id: EProductHeaderColumEnum.TITLE,
    headerName: 'Title',
    sortable: true,
  },
  {
    id: EProductHeaderColumEnum.PARTNERS,
    headerName: 'Involved partners',
    sortable: false,
  },
  {
    id: EProductHeaderColumEnum.MODIFIED_TIMESTAMP,
    headerName: 'Last edited',
    sortable: true,
  },
  {
    id: EProductHeaderColumEnum.ACTIONS,
    headerName: 'Actions',
    sortable: false,
  },
];
